import { ComponentView } from "binder";
import { CheckboxViewModel } from "./checkbox-viewModel"

export class CheckboxView extends ComponentView<CheckboxViewModel>{
    GetViewUniqueId(): string {
        return "V-71796C9F-D43F-47CC-9D2A-23AEC9A060F6"
    }
    loadHtml(): string {
        let element = require('./checkbox.html').default;
        let style = require('./checkbox.less');
        return element;
    }
    constructor() {
       super();
    }
    private checkbox:HTMLInputElement;

    public set content(v: string) { this._content = v; } public get content(): string { return this._content;} private _content: string;
    public set checked(v: boolean) { 
        this._checked = v; 
        this.checkbox.checked=v;
    } public get checked(): boolean { return this._checked;} private _checked: boolean;
    
    changed(){
        this.checked = this.checkbox.checked;
    }

    onRenderCompleted(){
        this.checkbox = this.firstlevelElement.querySelector('.V-71796C9F-D43F-47CC-9D2A-23AEC9A060F6.checkbox');
        
    }
}
